<template>
  <div class="send-search">
    <div class="head-tip-content flex">
      <WFormCreator ref="searchForm" :options="options">
        <template #after>
          <el-button type="primary" @click="fnSearch">查询</el-button>
          <el-button type="caicai" @click="exportExcel">批量导出</el-button>
          <el-button @click="refreshSearch">重置</el-button>
        </template>
      </WFormCreator>
    </div>
  </div>
</template>

<script>
import { drafts } from "@/api/index";
import { httpAgent } from "@/api/ajax";

export default {
  name: "CounterDeleteSearch",
  props: {
    content: String,
  },
  data () {
    return {
      options: {
        fnSearch: this.fnSearch,
        formItemAttrs: {
          houseBillNo: { type: 'input', label: '分提单号', placeholder: '请输入分提单号', width: '320px' },
          ackStatus: {
            type: 'select',
            label: '状态',
            selectOpts: [
              { label: '申请中', value: 'CCAM_COUNTER_DELETE_PENDING' },
              { label: '处理中', value: 'CCAM_COUNTER_DELETE_WAITING' },
              { label: '删除成功', value: 'CCAM_COUNTER_DELETE_SUCCESS' },
              { label: '删除失败', value: 'CCAM_COUNTER_DELETE_FAILURE' },
            ],
            placeholder: '请选择状态',
            multiple: true,
            width: '320px'
          },
          newOperator: {
            type: 'select',
            label: '提交人',
            selectOpts: [
              { label: '111', value: '1' }
            ],
            placeholder: '请选择提交人'
          },
          gmtModified: { type: 'daterange', label: '操作时间', width: '320px' },
        }
      }
    }
  },
  created(){
    this.getSubmitUserList()
  },
  methods: {
    // 提交人列表
    getSubmitUserList(){
      httpAgent({
        url: `/agent/ccam/customs/submitUserList`,
        method: "get",
      }).then((res) => {
        let arr = []
        res.forEach(item => {
          arr.push({
            label: item.nickName,
            value: item.userId,
          })
        })
        this.options.formItemAttrs.newOperator.selectOpts = arr
      })
    },
    fnSearch (query) {
      this.$emit('fnSearch', this.$refs.searchForm.getFormData())
    },
    // 重置
    refreshSearch(){
      this.$refs.searchForm.resetForm()
      this.$emit('refreshSearch')
    },
    // 导出
    exportExcel(){
      this.$emit('exportExcel', { ...this.$refs.searchForm.getFormData(), type: 'COUNTER_DELETE' })
    }
  }
};
</script>

<style scoped lang="less">
.send-search {
  border-radius: 4px;
  .head-tip-content {
    padding-left: 24px;
    font-size: 14px;
    margin-bottom: 10px;
  }
}
</style>